// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"28":"bc91c219","144":"8019891e","590":"88078638","835":"709fab3f","881":"39f7267b"}[chunkId] + ".js";
};